// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../rescript/lib/es6/list.js";
import * as React from "react";
import * as Caml_option from "../../../../rescript/lib/es6/caml_option.js";
import * as TertiaryButton$Catalyst from "../components/generic/buttons/TertiaryButton.bs.js";

function createViewFromList(list, seperator) {
  var newList = list ? list.tl : /* [] */0;
  return List.fold_left((function (viewString, listItem) {
                return viewString + (seperator + (" " + listItem));
              }), List.nth(list, 0), newList);
}

function extractLiveData(loadableData) {
  switch (loadableData.TAG | 0) {
    case /* Live */1 :
        return Caml_option.some(loadableData._0);
    case /* Loading */0 :
    case /* Error */2 :
        return ;
    
  }
}

function resolveEmptyText(resolveAsOpt, text) {
  var resolveAs = resolveAsOpt !== undefined ? resolveAsOpt : "";
  if (text !== undefined) {
    return {
            TAG: /* Text */0,
            _0: text
          };
  } else {
    return {
            TAG: /* Text */0,
            _0: resolveAs
          };
  }
}

function getCtaButtons(ctaBtnList) {
  return List.map((function (ctaBtn) {
                return React.createElement(TertiaryButton$Catalyst.make, {
                            className: "text-styling-cat-items navbar__ctaListItem",
                            onSelectCB: ctaBtn.onSelectCB,
                            children: ctaBtn.label
                          });
              }), ctaBtnList);
}

var CTAButtonHelper = {
  getCtaButtons: getCtaButtons
};

function toAmountString(amt) {
  var prefix = amt < 0.0 ? "-" : "";
  var value = Math.abs(amt).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return prefix + (" ₹" + value);
}

function toAmountStringWithPrecision(digitsOpt, amt) {
  var digits = digitsOpt !== undefined ? digitsOpt : 2;
  var prefix = amt < 0.0 ? "-" : "";
  var value = Math.abs(amt).toFixed(digits).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return prefix + (" ₹" + value);
}

export {
  createViewFromList ,
  extractLiveData ,
  resolveEmptyText ,
  CTAButtonHelper ,
  toAmountString ,
  toAmountStringWithPrecision ,
  
}
/* react Not a pure module */
